'use strict';

var React = require('react');

/* Stores */
var ModuleInspectorStore = require('stores/module-inspector');

/* Components */
var TitledGroup = require('components/ui/titled-group');
var TextField = require('components/ui/text-field');

var ModuleInspectorPropertyTypeText = React.createClass({
  displayName: 'ModuleInspectorPropertyTypeText',

  render: function render() {
    var component = this;
    var props = component.props;

    var placeholderTranslation = ModuleInspectorStore.translate(props.groupName + '_' + props.name);

    return React.createElement(
      'div',
      { className: 'color' },
      React.createElement(TextField, { value: props.value, ref: 'textfield', disabled: props.disabled, placeholder: placeholderTranslation, description: placeholderTranslation, onChange: component._onChange }),
      React.createElement('input', { ref: 'color', type: 'color', value: props.value, disabled: props.disabled, onChange: component._onColorChange })
    );
  },

  _onColorChange: function _onColorChange(evt) {
    var component = this;
    var props = component.props;
    var value = component.refs.color.getDOMNode().value;

    if (props.onChange) {
      /* Send original value and new value */
      props.onChange(props.value, value);
    }
  },

  _onChange: function _onChange(evt) {
    var component = this;
    var props = component.props;
    var value = component.refs.textfield.value;

    if (props.onChange) {
      /* Send original value and new value */
      props.onChange(props.value, value);
    }
  }
});

module.exports = ModuleInspectorPropertyTypeText;


/** WEBPACK FOOTER **
 ** ../~/babel-loader!./js/components/project/playground/module/inspector/type/color.js
 **/